// Nota: Todos os privilégios já estão cadastrados
// ========= totalPassageirosSPTransConsolidado =========
// Faz a contabilização dos dados de acordo com as regras de parâmetros especificadas
// http://smitgbc031:55360/api/v1/mobilidade/totalPassageirosSPTransConsolidado
// Privilégio: MOBILIDADE_TOTAL_PASSAGEIROS_SPTRANS_CONSOLIDADO
// -- Parâmetros --
// dataInicio: data de início que será passada na querystring no formato ISO (YYYY-MM-DD)
// Ex.: dataInicio=2021-03-01
// dataFim: data de início que será passada na querystring no formato ISO (YYYY-MM-DD)
// Ex.: dataFim=2021-04-30
// ** Caso nenhuma data seja passada, por padrão, traz tudo. Não precisa usar as duas juntas. Caso seja
// usado só a data nicio, os dados virão da dataInicio até a ultima data no banco. Caso seja usado
// só a dataFim, os dados virão do primeiro dado do banco até a dataFim.
// agrupamento: tipo de agrupamento que será considerado na hora de processar os dados. Caso nenhum seja
// passado, será considerado o DIARIO.
// - DIARIO
//  Traz os dados dia-a-dia, dentro da dataInicio e dataFim mencionada
// - MENSAL
//  Traz os dados mes-a-mes, dentro da dataInicio e dataFim mencionada (não contabiliza por dia da semana)
// - MENSAL_DIA_DA_SEMANA
//  Traz os dados mes-a-mes, dentro da dataInicio e dataFim mencionada (contabiliza por dia da semana)
// - ULTIMO_MES
//  Traz os dados do último mês, ignorando a dataInicio e dataFim passada (como se fosse um consolidado)
// - NENHUM
//  Não agrupa

// Exemplo de chamada:
// http://smitgbc031:55360/api/v1/mobilidade/totalPassageirosSPTransConsolidado?agrupamento=DIARIO&dataInicio=2021-07-01&dataFim=2021-07-31

// ========= totalPassageirosSPTransEstatisticaMes =========
// Traz a média e mediana mês-a-mês dos passageiros por dia de semana
// http://smitgbc031:55360/api/v1/mobilidade/totalPassageirosSPTransEstatisticaMes
// Privilégio: MOBILIDADE_TRANSPORTE_SPTRANS_TOTAL_PASSAGEIROS_ESTATISTICAS_MES
// -- Parâmetros --
// dataInicio: data de início que será passada na querystring no formato ISO (YYYY-MM-DD)
// Ex.: dataInicio=2021-03-01
// dataFim: data de início que será passada na querystring no formato ISO (YYYY-MM-DD)
// Ex.: dataFim=2021-04-30
// ** Caso nenhuma data seja passada, por padrão, traz tudo. Não precisa usar as duas juntas. Caso seja
// usado só a data nicio, os dados virão da dataInicio até a ultima data no banco. Caso seja usado
// só a dataFim, os dados virão do primeiro dado do banco até a dataFim.

// Exemplo de chamada:
// http://smitgbc031:55360/api/v1/mobilidade/totalPassageirosSPTransEstatisticaMes?dataInicio=2021-02-01&dataFim=2021-04-15

// ========= totalPassageirosSPTransTransportadosSazonal =========
// Traz a média e mediana do total de passageiros consolidado mês-a-mês dos dias da semana desde fev-2020
// http://smitgbc031:55360/api/v1/mobilidade/totalPassageirosSPTransTransportadosSazonal
// Privilégio: MOBILIDADE_TOTAL_PASSAGEIROS_SPTRANS_TRANSPORTADOS_SAZONAL
// -- Parâmetros --
// Não tem

// Exemplo de chamada:
// http://smitgbc031:55360/api/v1/mobilidade/totalPassageirosSPTransTransportadosSazonal

import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'

const RECURSO = '/mobilidade'
export default {
  totalPassageirosSPTransTransportadosSazonal,
  totalPassageirosSPTransEstatisticaMes,
  totalPassageirosSPTransConsolidado,
}

function totalPassageirosSPTransTransportadosSazonal () {
  return Error('Não use Esse Método Ainda')
  // return Api.get(`${RECURSO}/totalPassageirosSPTransTransportadosSazonal`)
};

function totalPassageirosSPTransEstatisticaMes ({ dataInicio = null, dataFim = null }) {
  let params = { 'dataInicio': dataInicio, 'dataFim': dataFim }
  return Api.get(`${RECURSO}/totalPassageirosSPTransEstatisticaMes${MetodosGlobais.createEncodeQuery(params)}`)
};

function totalPassageirosSPTransConsolidado ({ dataInicio = null, dataFim = null, agrupamento = null }) {
  let params = { 'dataInicio': dataInicio, 'dataFim': dataFim, 'agrupamento': agrupamento }
  return Api.get(`${RECURSO}/totalPassageirosSPTransConsolidado${MetodosGlobais.createEncodeQuery(params)}`)
};
